"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var rxjs_1 = require("rxjs");
var modal_options_model_1 = require("./modal-options.model");
var ModalService = (function () {
    function ModalService() {
    }
    ModalService.prototype.showApiMessageModal = function (options) {
        if (this.apiMessageModal) {
            return this.apiMessageModal.open(options);
        }
        return rxjs_1.Observable.of(null);
    };
    ModalService.prototype.registerApiMessageModalComponent = function (apiMessageModalComponent) {
        this.apiMessageModal = apiMessageModalComponent;
    };
    ModalService.prototype.showCustomersModalComponent = function (response) {
        if (this.customerModal) {
            return this.customerModal.open(response);
        }
        return rxjs_1.Observable.of(null);
    };
    ModalService.prototype.getCustomersModalComponentRef = function () {
        return this.customerModal;
    };
    ModalService.prototype.registerCustomersModalComponent = function (customersModalComponent) {
        this.customerModal = customersModalComponent;
    };
    ModalService.prototype.clearCustomersModalComponent = function () {
        this.customerModal = null;
    };
    ModalService.prototype.showMessageModal = function (title, message) {
        if (this.messageModal) {
            this.messageModal.open(title, message);
        }
    };
    ModalService.prototype.registerMessageModalComponent = function (messageModalComponent) {
        this.messageModal = messageModalComponent;
    };
    ModalService.prototype.clearMessageModalComponent = function () {
        this.messageModal = null;
    };
    ModalService.prototype.showLoadingModal = function (message) {
        if (this.loadingModal) {
            this.loadingModal.open(message);
        }
    };
    ModalService.prototype.hideLoadingModal = function () {
        var _this = this;
        if (this.loadingModal) {
            setTimeout(function () {
                // This is a hack until we find a better modal library
                _this.loadingModal.onCloseModal();
            }, 500);
        }
    };
    ModalService.prototype.registerLoadingModalComponent = function (loadingModal) {
        this.loadingModal = loadingModal;
    };
    ModalService.prototype.clearLoadingModalComponent = function () {
        this.loadingModal = null;
    };
    ModalService.prototype.getApiMessageModalOptions = function (title, messages) {
        var options = new modal_options_model_1.ModalOptions();
        options.title = title;
        options.apiErrorMessages = messages;
        options.continueButtonText = 'OKAY';
        return options;
    };
    return ModalService;
}());
ModalService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], ModalService);
exports.ModalService = ModalService;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/modals/modal.service.js